<template>
  <div>
  <v-switch
    :label="`Switch 1: ${item.hint.toString()}`"
    v-model="item.value"
    :hint="item.hint || undefined"
  ></v-switch>

</div>
</template>

<script>

'use strict'

export default {

  name: 'VuetifySwitch',

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },

  watch: {
    'item.value': function (newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item)
    }
  },

  methods: {
    focusNextField: function (event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-switch.vue